import type { PropsWithChildren } from "react";
import usePostHogFeatureFlag, {
  type TProps,
} from "@ch/helpers/utils/postHogAnalytics/usePostHogFeatureFlag.ts";
import NotFoundPage from "@ch/pages/NotFoundPage";

const FeatureFlagRouteGate = ({
  children,
  featureFlagName,
}: PropsWithChildren<TProps>) => {
  const {
    isFeatureFlagEnabled: isCorsanoEnabled,
    skipOnDev: skipCorsanoOnDev,
  } = usePostHogFeatureFlag({
    featureFlagName,
    skipOnDev: true,
  });

  return isCorsanoEnabled || skipCorsanoOnDev ? children : <NotFoundPage />;
};

export default FeatureFlagRouteGate;
